import React, { useState, useEffect } from "react";
import { EmissionIcon, SaveIcon } from "../../icons";
import {
  financialParameterType,
  SaveBtn,
  financialSetVariable,
  parameterSelectionTooltip,
} from "../../util/constants";
import { LoadingIndicatorEmbed } from "../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { UnitValidationModal } from "./UnitValidationModal";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../CommonUIComponents/Button/Button";
import { Select } from "../CommonUIComponents/Select/Select";
import "./FinancialsForm.scss";
import {
  saveDecarbGmpRuleMap,
  getParametersList,
  getruleList,
  getGMPRulesMapData,
} from "../../store/services/gmp.service";
import {
  setrulesMapData,
  setIsVariableApply,
  setUnitDetails,
} from "../../store/slices/gmpSlice";
import { LockerModalM3 } from "../LockerModal";
import { getLockingData } from "../../store/slices/projectSlice";
import { Tooltip } from "../CommonUIComponents/Tooltip/Tooltip";

export function FinancialsForm() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const engagement = useSelector((state) => state.engagement.engagement);
  const project = useSelector((state) => state.project.project);
  const [paramType, setParamType] = useState("");
  const [paramOptions, setParamOptions] = useState([]);
  const [ruleOptions, setRuleOptions] = useState([]);
  const [lockedData, setLock] = useState();
  const [lockedBy, setLockedby] = useState();
  const [isLockerModalOpen, setLockerModalOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [unitModalOpen, setUnitModalOpen] = useState(false);

  useEffect(() => {
    if (engagement?.id) {
      getRulesList();
      getParameterList();
    }
  }, [engagement?.id]);

  // to get a locked user flags
  useEffect(() => {
    const request = {
      LockedBy: user.username,
      ModuleName: "Project",
      EngagementID: project.projectId,
    };

    dispatch(getLockingData(request)).then((action) => {
      if (action) {
        const lockedData = action.payload?.data?.lockStatus;
        const lockedBy = action.payload?.data?.lockedBy;
        setLock(lockedData);
        setLockedby(lockedBy);
        if (lockedData === 2) {
          setLockerModalOpen(true);
        }
      }
    });
  }, [dispatch, project.projectId, lockedData]);

  const onSaveRuleMap = async () => {
    setShowLoader(true);
    dispatch(setIsVariableApply({ isVariableApply: false }));
    const request = {
      parameterName: paramType,
      projectID: project?.projectId,
      createdBy: user.username,
      modifiedBy: user.username,
      engagementCode: engagement.engagementCode,
      engagementID: engagement.id,
    };
    const data = await saveDecarbGmpRuleMap({ request });
    dispatch(setUnitDetails({ unitData: data }));
    getRulesMapData();
    setUnitModalOpen(true);
  };

  // Get GMP rules data to refresh table
  const getRulesMapData = async () => {
    const request = {
      projectId: project?.projectId,
    };
    const data = await getGMPRulesMapData({ request });
    dispatch(setrulesMapData({ rulesMapData: data }));
    setParamType("");
    setShowLoader(false);
  };

  //Onclick function on Simulate field
  const handleOnChange = (value, fieldName) => {
    if (fieldName === "paramType") {
      setParamType(value);
    }
  };

  // Get Parameters List
  const getParameterList = async (value) => {
    const request = {
      engagementId: engagement.id
    };
    const data = await getParametersList({ request });
    setParamOptions(data);
  };

  // Get Rule List
  const getRulesList = async () => {
    const request = {
      projectId: project?.projectId,
    };
    const data = await getruleList({ request });
    setRuleOptions(data);
  };

  return (
    <div className="financial-form-section">
      <div className="financial-form-title">
        <span>{financialSetVariable}</span>
      </div>
      <div className="financial-body-container">
        <div className="financial-form-body">
          <span className="form-lables">
            {financialParameterType}
            <span className="required-star">*</span>
            <Tooltip
              trigger={<EmissionIcon />}
              variant="ghost"
              tooltipText={parameterSelectionTooltip}
            ></Tooltip>
          </span>
          <Select
            options={paramOptions}
            multiple={true}
            showSelectAllButton={true}
            value={paramType}
            disabled={
              lockedData === 1 &&
              lockedBy !== user.username &&
              project.projectId
            }
            onChange={(event) => {
              // eslint-disable-next-line no-undef
              handleOnChange(event, "paramType");
            }}
          ></Select>
        </div>
        <div className="savebtn-btn">
          <LoadingIndicatorEmbed show={showLoader}>
            <Button
              variant="secondary"
              onClick={onSaveRuleMap}
              disabled={
                paramType === "" ||
                ruleOptions?.length === 0 ||
                (lockedData === 1 &&
                  lockedBy !== user.username &&
                  project.projectId)
              }
            >
              <SaveIcon />
              &nbsp;{SaveBtn}
            </Button>
          </LoadingIndicatorEmbed>
        </div>
        {lockedData === 2 &&
          lockedBy === user?.username &&
          project?.projectId && (
            <LockerModalM3
              isOpen={isLockerModalOpen}
              onClose={() => setLockerModalOpen(false)}
            />
          )}
      </div>
      <UnitValidationModal
        isUnitModalOpen={unitModalOpen}
        onClose={() => setUnitModalOpen(false)}
      />
    </div>
  );
}
